export default __webpack_public_path__ + "static/media/guided-notes.b9e02ebb469f33472c8a478e4accde17.svg";